import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation('footer');

  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="sm:col-span-2 lg:col-span-1">
              <Link to="/" className="flex items-center gap-2.5 mb-4 group whitespace-nowrap">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg transition-transform duration-300 group-hover:scale-110">
                  <i className="ri-fire-fill text-background-50 text-lg"></i>
                </div>
                <span className="font-heading font-bold text-lg">开云体育</span>
              </Link>
              <p className="text-foreground-400 text-sm leading-relaxed mb-5">
                {t('footer_description')}
              </p>
            </div>

            <div>
              <strong className="text-sm font-heading font-semibold uppercase tracking-wider text-background-50 mb-4 block">
                {t('footer_categories')}
              </strong>
              <ul className="space-y-2.5">
                {categories.slice(0, 5).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <strong className="text-sm font-heading font-semibold uppercase tracking-wider text-background-50 mb-4 block">
                {t('footer_quick_links')}
              </strong>
              <ul className="space-y-2.5">
                <li>
                  <Link
                    to="/about"
                    className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 whitespace-nowrap"
                  >
                    {t('footer_about')}
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 whitespace-nowrap"
                  >
                    {t('footer_privacy')}
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 whitespace-nowrap"
                  >
                    {t('footer_terms')}
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <strong className="text-sm font-heading font-semibold uppercase tracking-wider text-background-50 mb-4 block">
                {t('footer_contact')}
              </strong>
              <ul className="space-y-2.5 text-sm text-foreground-400">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line text-primary-400 w-4 h-4 flex items-center justify-center"></i>
                  <span>{t('footer_email')}</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-phone-line text-primary-400 w-4 h-4 flex items-center justify-center"></i>
                  <span>{t('footer_phone')}</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-time-line text-primary-400 w-4 h-4 flex items-center justify-center mt-0.5"></i>
                  <span>{t('footer_address')}</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-500 text-xs">
              {t('footer_copyright')}
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-all duration-300 cursor-pointer" aria-label="WeChat">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-all duration-300 cursor-pointer" aria-label="Weibo">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-all duration-300 cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}